<template>
  <div class="user">
    <el-form :inline="true" :model="formInline" class="form">
      <el-form-item label="用户昵称">
        <el-input v-model="formInline.nickname" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <!-- <el-input v-model="formInline.mobile" placeholder="手机号"></el-input> -->
        <el-select v-model="formInline.mobile" filterable placeholder="手机号" clearable >
          <el-option
            v-for="item in optionsMobile"
            :key="item.mobile"
            :label="item.mobile"
            :value="item.mobile"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList" class="form_btn">
          <img src="../assets/static/query.png" class="btn_img" />查询
        </el-button>
      </el-form-item>
    </el-form>
    <div class="sorting">
      <div class="export_btn" style="margin-right: 20px;">导出</div>
    </div>
    <div
      class="table_list"
      style="flex-grow: 1;overflow-y: scroll;"
      
      ref="tableRef"
    >
      <!-- :row-class-name="tableRowClassName" -->
          <!-- :height="tableData.length > 0 ? tableHeight : ''" -->
      <el-table :data="tableData" border style="width: 100%;" :height="tableData.length > 0 ? tableHeight : ''" :row-style="tableRowStyle">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop="id" label="id" width="60"></el-table-column>
        <el-table-column align="center" prop="nickname" label="用户昵称"></el-table-column>
        <el-table-column align="center" prop="mobile" label="用户手机号" width="180"></el-table-column>
        <el-table-column align="center" prop="price" label="消费金额" v-if="typeNew != 3">
          <template slot-scope="scope">{{ scope.row.price }}元</template>
        </el-table-column>
        <el-table-column align="center" prop="num" label="消费次数" v-if="typeNew != 3">
          <template slot-scope="scope">{{ scope.row.num }}次</template>
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="取货次数" v-if="typeNew == 3">
          <template slot-scope="scope">{{ scope.row.total }}次</template>
        </el-table-column>
        <el-table-column align="center" prop="zip" label="是否拉黑">
          <template slot-scope="scope">
            <img
              src="../assets/static/inspectionOpen.png"
              alt
              @click="changeBtn(scope.row)"
              style="width: 72px;"
              v-if="scope.row.is_block == 1"
            />
            <img
              src="../assets/static/inspectionClose.png"
              alt
              @click="changeBtn(scope.row)"
              style="width: 72px;"
              v-if="scope.row.is_block == 0"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="注册时间" width="300"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="322">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" class="right_btn">修改</el-button>
            <el-button
              @click="handleClickDelete(scope.row)"
              type="text"
              class="right_btn right_btn_color"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>
<script>
import { userListIndex, UserMobile, Userblock } from "@/utils/api/index";

export default {
  name: "userList",
  // typeUser 1用户列表 2黑名单 3 骑手列表
  props: ["typeUser"],
  data() {
    return {
      formInline: {
        mobile: "",
        nickname: ""
      },
      currentPage: 1,
      tableData: [],
      pageSize: 10,
      total: 0,
      optionsMobile: [],
      tableHeight: 0,
      typeNew: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      const div = this.$refs.tableRef;
    this.tableHeight = div.offsetHeight;
    })
    
    // this.typeNew = this.typeUser
    this.getList();
    this.getUserMobile();
  },
  watch:{
    typeUser(newY,ordy) {
      console.log(ordy,newY,newY != -1,this.typeOeder,'typeOedertypeOedertypeOeder')
      if(newY != -1) {
        this.typeNew = newY
        console.log(this.typeNew,'this.typeNewthis.typeNewthis.typeNew')
        this.getList()
      }
    }
  },
  methods: {
    handleClickDelete() {
      // this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.$message({
      //       type: "success",
      //       message: "删除成功!"
      //     });
      //   })
      //   .catch(() => {
          
      //   });
    },
    getList(type) {
      if(type == 1) {
        this.total = 0;
        this.tableData = [];
      }
      userListIndex({
        store_id: undefined,
        page: this.currentPage,
        limit: this.pageSize,
        nickname: this.formInline.nickname,
        mobile: this.formInline.mobile,
        is_block: this.typeUser != 2 ? undefined : 1,
        is_level: this.typeUser == 1 ? 1 : (this.typeUser == 3 ? 0 : undefined)
      }).then(res => {
        this.total = res.data.count;
        this.tableData = res.data.data;
      });
    },
    getUserMobile() {
      UserMobile({
        is_block: this.typeUser == 1 ? undefined : 1
      }).then(res => {
        this.optionsMobile = res.data;
      });
    },
    changeBtn(row) {
      Userblock({
        is_block: row.is_block == 1 ? 0 : 1,
        id: row.id
      }).then(res => {
        this.$message.success(res.message);
        this.getList();
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      console.log(e, "current");
      this.currentPage = e;
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
      //   return "";
    },
    tableRowStyle({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return {
          background: "#16264a"
        };
      } else {
        return {
          background: "#0d193c"
        };
      }
    }
  }
};
</script>
<style scoped lang="scss">
.user {
  // padding: 20px;
  height: calc(100% - 74px);
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  background: #213456;
  display: flex;
  flex-direction: column;
}
.form {
  margin-left: 30px;
  color: #d4e6ff !important;
  :deep(.el-form-item__label) {
    font-size: 14px;
    color: #d4e6ff;
  }
  :deep(.el-input__inner) {
    height: 36px;
    background: #051238;
    border-radius: 2px;
    color: #ffffff;
  }
  .form_btn {
    width: 90px;
    height: 36px;
    background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
    border-radius: 4px;
    border: 1px solid #5fbcf5;
    .btn_img {
      width: 16px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }
}
.table_list {
  margin: 30px;
  box-sizing: border-box;
  margin-top: 0;
  flex-grow: 1;
  overflow-y: scroll;
  :deep(.el-table__body tr.hover-row > td) {
    background-color: transparent !important;
  }
  .el-table {
    background-color: #0d193c;
    border: 1px solid #2f416b;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: transparent;
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    background: transparent !important;
  }
}
.sorting {
  display: flex;
  align-items: center;
  height: 64px;
  background: #29456e;
  margin: 30px;
  margin-top: 35px;
  margin-bottom: 0;
  padding-left: 30px;
  box-sizing: border-box;
  .export_btn {
    height: 32px;
    background: #29456e;
    border-radius: 4px;
    border: 1px solid #3dc1ff;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 32px;
    padding: 0 20px;
  }
}
.right_btn {
  width: 90px;
  height: 36px;
  background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
  border-radius: 4px;
  border: 1px solid #5fbcf5;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  padding-bottom: 28px;
}
.right_btn_color {
  background: linear-gradient(180deg, #a9801d 0%, #b56625 100%);
  border-radius: 4px;
  border: 1px solid #fcd486;
}
.right_btn_color_big {
  background: linear-gradient(180deg, #0e6871 0%, #25b587 100%);
  border-radius: 4px;
  border: 1px solid #5fbcf5;
}
.el-pagination {
  text-align: center;
  margin-top: 24px;
  margin-bottom: 14px;
}
.pagination {
  :deep(.el-pagination__total) {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.88);
    margin-top: 4px;
  }
  :deep(.el-input__inner) {
    background: #051238;
    border-radius: 6px;
    font-size: 16px;
    color: #cccccc;
    border: 0;
    margin-top: 4px;
  }
  :deep(.btn-prev) {
    width: 36px;
    height: 36px;
    background: #29456e;
    border-radius: 7px;
  }
  :deep(.el-pager li) {
    width: 36px;
    height: 36px;
    border-radius: 7px;
    background: #29456e;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #ffffff;
    line-height: 36px;
    font-size: 18px;
    border-radius: 7px;
    margin: 0 5px;
  }
  :deep(.btn-next) {
    width: 36px;
    height: 36px;
    background: #29456e;
    border-radius: 7px;
  }
  :deep(.el-pagination__jump) {
    font-size: 18px;
    margin-top: 4px;
  }
  :deep(.el-pager li.active) {
    background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%) !important;
    border: 1px solid #5fbcf5;
  }
}
.table_list::-webkit-scrollbar {
  width: 3px !important; /* 滚动条宽度 */
}
:deep(thead .el-table__cell) {
  background-color: #16264a !important;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
}
</style>
